export default "__VITE_PUBLIC_ASSET__37dafc5e__"